export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5480.0e2ab2e5.jpg";